import { Box, Typography } from "@mui/material";

export type AreaHotkeyMap = Readonly<Record<string, string>>;
export type AreaColorMap = Readonly<Record<string, string>>;
export type AreaMaterialsMap = Readonly<Record<string, string>>;

export const UNMAPPED_AREA_COLOR = "rgba(60, 60, 60, 0.8)";

export const BAY_ITEM_WIDTH = 120;
export const BAY_ITEM_HEIGHT = 75;

export const RAILCAR_CONNECTOR_LENGTH = 12;
export const RAILCAR_CONNECTOR_THICKNESS = 8;
export const TRACK_END_BAR_LENGTH = 20;
export const TRACK_END_BAR_THICKNESS = 2;
export const TRACK_END_BAR_GAP = 4;
export const TRACK_END_CONNECTOR_LENGTH =
  TRACK_END_BAR_LENGTH * 2 + TRACK_END_BAR_GAP;
export const AREA_SPACER_LENGTH = 12;

export const AREA_ITEM_SIZES = {
  railcar: {
    normal: { width: 100, height: 70 },
    small: { width: 70, height: 55 },
  },
  square: {
    normal: { width: 140, height: 80 },
    small: { width: 100, height: 60 },
  },
  circle: {
    normal: { width: 90, height: 90 },
    small: { width: 70, height: 70 },
  },
} as const;

export type BaseAreaItemProps = Readonly<{
  areaId: string;
  displayName: string;
  onClick?: (areaId: string) => void;
  isSelectable?: boolean;
  hotkey?: string;
  material?: string;
  overrideColor?: string;
  useNeutralFallback?: boolean;
  isSelected?: boolean;
  isDimmed?: boolean;
  isAwaitingMaterial?: boolean;
}>;

export const KeyboardKey = ({
  hotkey,
  size = 28,
}: {
  hotkey: string;
  size?: number;
}) => (
  <Box
    sx={{
      minWidth: size,
      height: size,
      px: 0.75,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "#f5f5f5",
      borderRadius: "4px",
      border: "1px solid #ccc",
      borderBottom: "3px solid #999",
      boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
    }}
  >
    <Typography
      sx={{
        color: "#333",
        fontWeight: "bold",
        fontFamily: "monospace",
        fontSize: "0.8rem",
        lineHeight: 1,
      }}
    >
      {hotkey}
    </Typography>
  </Box>
);

export const HotkeyBadge = ({ hotkey }: { hotkey: string }) => (
  <Box sx={{ mt: 0.5 }}>
    <KeyboardKey hotkey={hotkey} />
  </Box>
);
